import { useEffect } from 'react';
import { useController } from 'react-hook-form';
import useGeneratorStore from '@/state/generator-store';
import { SessionType } from '@/hooks/useSessionStore';
import JenErrorToast from '@/components/ui/jen-error-toast';
import { toast } from 'sonner';

export const useQualityControl = (defaultValue: string, session: SessionType) => {
  const { register, control, generatorForm } = useGeneratorStore((state) => ({
    register: state.register,
    control: state.control,
    generatorForm: state.generatorForm,
  }));

  const {
    field: { value, onChange },
  } = useController({
    name: 'quality',
    control,
  });

  const { setValue } = generatorForm ?? {};

  const toggleQuality = () => {
    if (session.user.plan.key === 'base') {
      return toast(
        <JenErrorToast
          error={new Error(`${session.user.plan.name} does not have access to quality .wav. Please upgrade to use this feature.`)}
        />,
        {
          className: '!border-0 !shadow-none',
          unstyled: true,
        },
      );
    }
    const newValue = value === 'mp3' ? 'wav' : 'mp3';
    onChange(newValue);
    setValue?.('quality', newValue);
  };

  useEffect(() => {
    register('quality');
    onChange(defaultValue);
    setValue?.('quality', defaultValue);
  }, [register, defaultValue]);

  return {
    value,
    toggleQuality,
  };
};
